<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
        :sidebar-item-color="sidebarBackground"
        :sidebar-background-image="sidebarBackgroundImage"
    >
      <li class="md-list-item" to="/app/dashboard">
        <a
            v-on:click="pushRoute('/app/dashboard')"
            v-bind:class="getStyles('/app/dashboard')"
            id="dashboardButton"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>dashboard</md-icon>
            <p>Dashboard</p>
          </div>
        </a>
      </li>
      <li class="md-list-item" to="/app/articles">
        <a
            v-on:click="pushRoute('/app/articles')"
            v-bind:class="getStyles('/app/articles')"
            id="articlesButton"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>construction</md-icon>
            <p>{{ $t("articles_title") }}</p>
          </div>
        </a>
      </li>
      <li class="md-list-item" to="/app/orders">
        <a
            v-on:click="pushRoute('/app/orders')"
            v-bind:class="getStyles('/app/orders')"
            id="ordersButton"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>list_alt</md-icon>
            <p>{{ $t("orders_title") }}</p>
          </div>
        </a>
      </li>
      <li class="md-list-item" to="/app/kanban-tuner">
        <a
            v-on:click="pushRoute('/app/kanban-tuner')"
            v-bind:class="getStyles('/app/kanban-tuner')"
            id="kanbanTunerButton"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>more_time</md-icon>
            <p>Kanban Tuner</p>
          </div>
        </a>
      </li>
      <!--<sidebar-link to="/app/supplier-rating">
        <md-icon>local_shipping</md-icon>
        <p>Lieferantenauswertung</p>
      </sidebar-link>
      <sidebar-link to="/app/tenders">
        <md-icon>price_check</md-icon>
        <p>Preisausschreibung</p>
      </sidebar-link>-->
      <li class="md-list-item" to="/app/elkasy" v-if="renderElProcSy()">
        <a
            v-on:click="pushRoute('/app/elkasy')"
            v-bind:class="getStyles('/app/elkasy')"
            id="elprocsyButton"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>storefront</md-icon>
            <p>el/ka/sy® On-Demand</p>
          </div>
        </a>
      </li>
      <li class="md-list-item active-pro logout">
        <a
            id="logoutButton"
            v-on:click="logout()"
            class="md-list-item-router md-list-item-container md-button-clean"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>logout</md-icon>
            <p>Logout</p>
          </div>
        </a>
      </li>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content> </dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import store from "@/store/index.js";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
  },
  data() {
    return {
      sidebarBackground: "purple",
      sidebarBackgroundImage: require("@/assets/img/sidebar_background.jpg"),
    };
  },
  methods: {
    logout() {
      store.commit("logout");
      this.$router.push("/");
    },
    getStyles(route) {
      if (this.$route.fullPath === route)
        return 'md-list-item-router md-list-item-container md-button-clean nav-item active router-link-active';
      else
        return 'md-list-item-router md-list-item-container md-button-clean';
    },
    pushRoute(route) {
      this.$router.push(route);
    },
    renderElProcSy() {
      return (
          store.state.user.org == 6276201 ||
          store.state.user.org == 5949363 ||
          store.state.user.org == 1508 ||
          store.state.user.org == 6153821 ||
          store.state.user.org == 2418597 ||
          store.state.user.org == 5876811 ||
          store.state.user.org == 1669
      );
    },
  },
};
</script>

<style lang="scss">
.logout {
  bottom: 10px !important;
  width: 98% !important;
}
</style>
